import { useAuth } from 'src/auth/AuthContext';
import React, { useState } from 'react';
import {
  CircularProgress,
  Container,
  Typography,
  Grid,
  Paper,
  Avatar,
  TextField,
  Button
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Expandable from '../../components/Expandable';
import { getAuth, updateProfile } from 'firebase/auth';

const UserPage: React.FC = () => {
  const user = useAuth();
  const [editingDisplayName, setEditingDisplayName] = useState(user.displayName || `${user.firstName} ${user.lastName}`);
  const [editedField, setEditedField] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingDisplayName(e.target.value);
    setEditedField('displayName');
  };

  const handleSave = async () => {
    if (editedField === 'displayName') {
      const auth = getAuth();
      if (auth.currentUser) {
        try {
          await updateProfile(auth.currentUser, { displayName: editingDisplayName });
          // Optionally, dispatch an action to update the user state in Redux
        } catch (error) {
          console.error('Error updating display name:', error);
        }
      }
    }
  };

  if (user.loading) {
    return (
      <Container
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ width: '100%' }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper style={{ padding: '20px', textAlign: 'center' }}>
            <Avatar
              src={`https://ui-avatars.com/api/?name=${user.firstName}+${user.lastName}`}
              alt={user.displayName || `${user.firstName} ${user.lastName}`}
              style={{ width: '100px', height: '100px', margin: '0 auto' }}
            />
            <Expandable>
              <Expandable.Closed>
                <Typography variant='h4' gutterBottom>
                  {user.displayName || `${user.firstName} ${user.lastName}`}
                </Typography>
              </Expandable.Closed>
              <Expandable.Open>
                <TextField
                  variant='standard'
                  size='small'
                  label='Display Name'
                  name='displayName'
                  value={editingDisplayName}
                  onChange={handleInputChange}
                />
              </Expandable.Open>
              <Expandable.OpenButton>
                <EditIcon />
              </Expandable.OpenButton>
              <Expandable.CloseButton>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleSave}
                >
                  Save Changes
                </Button>
              </Expandable.CloseButton>
            </Expandable>
            <Typography variant='subtitle1' gutterBottom>
              {user.email}
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              Email Verified: {user.emailVerified ? 'Yes' : 'No'}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper style={{ padding: '20px' }}>
            <Typography variant='h6' gutterBottom>
              User Information
            </Typography>
            <Typography>First Name: {user.firstName}</Typography>
            <Typography>Last Name: {user.lastName}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default UserPage;
